var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5455 0.470588C13.7382 0.141176 12.8509 0 12 0C10.5818 0 9.05455 0.376471 8 1.41176C6.94545 0.376471 5.41818 0 4 0C2.58182 0 1.05455 0.376471 0 1.41176V15.2C0 15.4353 0.181818 15.6706 0.363636 15.6706C0.436364 15.6706 0.472727 15.6235 0.545455 15.6235C1.52727 15.0118 2.94545 14.5882 4 14.5882C5.41818 14.5882 6.94545 14.9647 8 16C8.98182 15.2 10.7636 14.5882 12 14.5882C13.2 14.5882 14.4364 14.8706 15.4545 15.5765C15.5273 15.6235 15.5636 15.6235 15.6364 15.6235C15.8182 15.6235 16 15.3882 16 15.1529V1.41176C15.5636 0.988235 15.0909 0.705882 14.5455 0.470588ZM14.5455 13.1765C13.7455 12.8471 12.8727 12.7059 12 12.7059C10.7636 12.7059 8.98182 13.3176 8 14.1176V3.29412C8.98182 2.49412 10.7636 1.88235 12 1.88235C12.8727 1.88235 13.7455 2.02353 14.5455 2.35294V13.1765Z",
    fill: "#FF5391"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon1.45e4c6b75c269b3771ee09bec0bd3879.svg";
export { ForwardRef as ReactComponent };